import JiaMengHeader from '@components/JiaMeng/Header/Order'
import React from 'react'
import { asyncLoad } from '@util'
import Notice from '@components/LocalMerchant/IncomeManage/Notice'

const AsyncIncomeManage = asyncLoad(() =>
  import('@components/LocalMerchant/IncomeManage/Manage')
)
const AsyncEnsureMoney = asyncLoad(() =>
  import('@components/LocalMerchant/IncomeManage/EnsureMoney')
)
const AsyncExtractInfo = asyncLoad(() =>
  import('@components/LocalMerchant/IncomeManage/ExtractInfo')
)
const AsyncHelp = asyncLoad(() =>
  import('@components/LocalMerchant/IncomeManage/Help')
)
const AsyncExtractInfoDetail = asyncLoad(() =>
  import('@components/LocalMerchant/IncomeManage/Detail')
)

export default {
  path: 'incomeManage',
  component: props => <JiaMengHeader key="incomeManage" {...props} />,
  indexRoute: {
    component: AsyncIncomeManage
  },
  stat: '收入管理/首页',
  childRoutes: [
    {
      path: 'ensureMoney',
      component: AsyncEnsureMoney,
      stat: '收入管理/放心购·保证金明细'
    },
    {
      path: 'extractInfo',
      indexRoute: {
        component: AsyncExtractInfo
      },
      stat: '收入管理/提现记录',
      childRoutes: [
        {
          path: ':id',
          component: AsyncExtractInfoDetail
        }
      ]
    },
    {
      path: 'help',
      component: AsyncHelp,
      stat: '收入管理/常见问题'
    },
    {
      path: 'notice',
      component: Notice
    }
  ]
}
